module.exports = __webpack_public_path__ + "static/img/call-pass.070b97d4.png";